import { StateCreator } from "zustand";
import { ICart } from "../../constants/types";
import type { TransaksiStore } from "../transaksiStore";

export interface PaymentSlice {
    totalHarga: number;
    bayar?: number | null;
    kembalian: number;
    diskon: number;
    grandTotal: number;
    hitungHarga: (cart: ICart[]) => void;
    hitungBayar: (digit: number) => void;
    resetBayar: () => void;
    hitungKembalian: () => void;
    hitungGrandTotal: () => void;
    aturDiskon: (
        digit: number,
        toggleDiskon: "nominal" | "persentase",
    ) => void;
    uangPas: () => void;
    resetPayment: () => void;
}

export const createPaymentSlice: StateCreator<
    TransaksiStore,
    [],
    [],
    PaymentSlice
> = (set, get) => ({
    totalHarga: 0,
    bayar: null,
    kembalian: 0,
    diskon: 0,
    grandTotal: 0,
    hitungHarga: (cart) => {
        let total = 0;
        cart.forEach((c) => {
            total += c.harga * c.qty;
        });
        set({ totalHarga: total });
    },
    hitungBayar: (digit) => set({ bayar: digit }),
    resetBayar: () => set({ bayar: null }),
    hitungKembalian: () => {
        const { bayar, diskon, totalHarga, grandTotal } = get();
        if (bayar === 0 || bayar === null) {
            set({ kembalian: 0 });
        } else if (diskon === 0) {
            set({ kembalian: (bayar ?? 0) - totalHarga });
        } else {
            set({ kembalian: (bayar ?? 0) - grandTotal });
        }
    },
    hitungGrandTotal: () => {
        const { totalHarga, diskon } = get();
        set({ grandTotal: totalHarga - diskon });
    },
    aturDiskon: (digit, toggleDiskon) => {
        const { totalHarga } = get();
        if (toggleDiskon === "nominal") {
            set({ diskon: digit });
        } else if (toggleDiskon === "persentase") {
            const potongan = digit / 100;
            const totalDiskon = totalHarga - totalHarga * potongan;
            set({ diskon: totalHarga - totalDiskon });
        }
    },
    uangPas: () => {
        const { diskon, totalHarga, grandTotal } = get();
        set({ bayar: diskon === 0 ? totalHarga : grandTotal });
    },
    resetPayment: () =>
        set({
            totalHarga: 0,
            bayar: null,
            kembalian: 0,
            diskon: 0,
            grandTotal: 0,
        }),
});
